import script from "./CMPPanelResumen.vue?vue&type=script&setup=true&lang=js"
export * from "./CMPPanelResumen.vue?vue&type=script&setup=true&lang=js"

import "./CMPPanelResumen.vue?vue&type=style&index=0&id=057f2afb&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-057f2afb"]])

export default __exports__